module.exports = __webpack_public_path__ + "img/cases-brand-chinamobile-16.60368dce.jpg";